<template>
	<div id="wednesday">
		<div class="container">

			<div class="companyInfoIpt">
				<div class="tabContainer">
					
					<div class="tabItem" :class="{ active: activeTab === 'live' }" @click="changeTab('live')">线上宣讲报名</div>
                    <div class="tabItem" :class="{ active: activeTab === 'campus' }" @click="changeTab('campus')">进校宣讲报名</div>
				</div>

				<div v-if="activeTab === 'campus'" class="campusForm">
					<div class="bg campusBg" @click="openPDF">
						<div class="title">进校宣讲报名</div>
						<div class="subheading">
							<div>活动介绍</div>
							<img src="../img/more3.png" alt="" />
						</div>
					</div>

					<div class="ipt campusTime">
						<div class="text"><span style="color:#FF4A4A">*</span>宣讲时间：</div>
						<el-date-picker v-model="campusForm.stime" @change="campusStartTimeChange" type="datetime"
							:style="campusForm.stime ? 'margin-right: 10px;' : ''" placeholder="请选择宣讲开始时间"
							:picker-options="campusPickerOptions" format="yyyy-MM-dd HH:mm">
						</el-date-picker>
						<el-date-picker v-if="campusForm.stime" v-model="campusForm.etime" :disabled="campusForm.isSelect" :default-value="campusForm.stime"
							type="datetime" placeholder="请选择宣讲结束时间" :picker-options="campusPickerOptions1"
							@change="campusEtimeChange" format="yyyy-MM-dd HH:mm">
						</el-date-picker>
					</div>

					<div class="ipt campusTextarea">
						<div class="text"><span style="color:#FF4A4A">*</span>宣讲场次：</div>
						<el-input v-model="campusForm.session" type="textarea" :rows="3" placeholder="请输入宣讲场次的主题、内容等"></el-input>
					</div>
					<div class="ipt campusTextarea">
						<div class="text"><span style="color:#FF4A4A">*</span>高校类型：</div>
						<el-input v-model="campusForm.schoolType" type="textarea" :rows="3" placeholder="请填写高校类型"></el-input>
					</div>
					<div class="ipt campusTextarea campusTextareaLarge">
						<div class="text"><span style="color:#FF4A4A">*</span>具体高校：</div>
						<el-input v-model="campusForm.schools" type="textarea" :rows="6" placeholder="例如：南京大学、哈尔滨工业大学、武汉大学、华中科技大学、北京航空航天大学、南开大学"></el-input>
					</div>
					<div class="btnContainer">
						<el-button class="cancel" v-if="isCampusAmend" @click="cancelCampus">取消报名</el-button>
						<el-button type="primary" @click="submitCampus">{{isCampusAmend ? '修改报名' : '提交报名'}}</el-button>
					</div>
				</div>

				<div v-else>
				<!-- <div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						周三名企宣讲报名
					</div>
				</div> -->
				<!-- <img src="../img/jobShadowing3.png" alt="" style="width: 700px;height: 150px;margin-bottom: 30px;cursor: pointer;" @click="openPDF"/> -->
				<div class="bg" @click="openPDF">
					<div class="title">
						线上宣讲报名
					</div>
					<div class="subheading">
						<div class="">
							活动介绍
						</div>
						<img src="../img/more3.png" alt="" />
					</div>
				</div>
				<div class="iptContainer" v-for="(item,index) in liveList" :key="index">

					<!-- <div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span>直播操作：</span>
						</div>
						<el-button type="primary" style="background: #0084FF;" v-if="item.xet_alive_code"
							@click="liveStreaming(item.xet_alive_code)">点击开启直播</el-button>
						<el-button type="danger" :disabled='item.id?false:true' @click="deleteItem(index)">删除直播</el-button>
					</div> -->

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播标题：
						</div>
						<el-input v-model="item.title" placeholder="请输入直播标题" maxlength="15"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;" @click="selectTime(index)">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播时间段：
						</div>

						<!-- <el-date-picker v-model="item.value1" @change='timeChange(index)' type="datetimerange" start-placeholder="开始日期"
							end-placeholder="结束日期" :picker-options="pickerOptions">
						</el-date-picker> -->

						<el-date-picker v-model="item.stime" @change='startTimeChange' type="datetime"
							:style="item.stime?'margin-right: 10px;':''" placeholder="请选择直播开始时间"
							:picker-options="pickerOptions" format="yyyy-MM-dd HH:mm">
						</el-date-picker>

						<el-date-picker v-model="item.etime" :disabled='item.isSelect' :default-value="item.stime" type="datetime" v-if='item.stime'
							placeholder="请选择直播结束时间" :picker-options="pickerOptions1" @change='etimeChange(index)'
							format="yyyy-MM-dd HH:mm">
						</el-date-picker>

					</div>


					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人：
						</div>
						<el-input v-model="item.event_person" placeholder="请输入主讲人姓名" maxlength="15"></el-input>
					</div>



					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人头衔：
						</div>
						<el-input v-model="item.header_intr" placeholder="请输入主讲人头衔" maxlength="20"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人手机号：
						</div>
						<el-input v-model="item.phone" placeholder="请输入主讲人手机号" maxlength="11"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人介绍：
						</div>
						<el-input type="textarea" autosize placeholder="请输入主讲人介绍" v-model="item.person_desc"
							maxlength="200" show-word-limit>
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px; align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播内容简介：
						</div>
						<el-input type="textarea" autosize v-model="item.event_desc"
							placeholder="企业招聘宣讲、学生应聘咨询、线上访企探岗、导师职业指导。" maxlength="300" show-word-limit></el-input>
					</div>

					<div class="companyContainer" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播海报：
						</div>

						<div class="company">
							<div class="top">
								<div class="" style="font-weight: 400;font-size: 14px;color: #C0C4CC;flex: 1;">
									请上传您所需要的直播海报
								</div>
								<!-- <el-input v-model="name"  placeholder="请上传您所需要的直播海报"></el-input> -->
								<div class="uplodadCompany1">
									<el-upload class="avatar-uploader1"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<!-- <img  src="" class="avatar"> -->
										<div class="uplodadCompany" @click="selectIndex(index)">
											<img src="../img/xiangji.png" alt="" />
											<div class="btn">
												上传直播海报
											</div>
										</div>
									</el-upload>
								</div>
							</div>
							<div class="companyImg">
								<div class="closeContainer" v-if="item.event_img" style="position: relative;">
									<img v-if="item.event_img" :src="item.event_img" class="avatar"
										style="width: 195px !important;height: 120px !important;border-radius: 5px;">
									<img class="closeImg" src="../img/close1.png" alt="" @click.stop="delWeixin(index)"
										style="width: 15px;height: 15px;position: absolute;right: 5px;top: 5px;cursor: pointer;border-radius: 50%;background: rgba(255, 255, 255, 0.8);padding: 2px;" />
								</div>
								<!-- <img :src="item.event_img" alt="" v-if="item.event_img" /> -->
								<div v-else class=""
									style="width: 195px;height: 120px;background: #f9fbff;border-radius: 5px;text-align: center;line-height: 120px;margin-right: 15px;font-weight: 500;font-size: 18px;color: #BEC6D2;">
									直播海报
								</div>
								<div class="">
									<span style="margin-bottom: 5px;">海报比例16:9，海报大小10M内</span>
									<span style="margin-bottom: 5px;">支持格式:JPG、PNG、JPEG</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="addNewContainer">
					<div class="addNew" @click="addLive">
						添加新的直播 +
					</div>
				</div> -->
				<div class="btnContainer">
					<!--  -->
					<el-button type="primary" @click="liveStreaming(liveList[0].xet_alive_code)"
						v-if="liveList[0].xet_alive_code">预览</el-button>
					<el-button class="cancel" @click="cancel" v-if="isAmend">取消</el-button>
					<el-button type="primary" @click="submit">{{isAmend?'修改报名':'提交报名'}}</el-button>
				</div>
				</div>
			</div>
		</div>

		<el-dialog :visible.sync="dialogVisible" :show-close='false' width="800px">
			<div class="elDialog">
				<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
				<div class="main">
					<div class="title">直播二维码</div>
					<div class="qrcodeContainer">
						<div class="qrcode">
							<img :src="xet_alive_code" alt="" />

							<div class="hite1">
								扫描<span style="color:#0084FF;">识别二维码</span>
							</div>
							<div class="hite2">
								开启直播
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				activeTab: 'live',
				campusForm: {
					stime: '',
					etime: '',
					session: '',
					schoolType: '',
					schools: '',
					isSelect: true,
				},
				isCampusAmend: false,
				campusFormSnapshot: JSON.stringify({
					stime: '',
					etime: '',
					session: '',
					schoolType: '',
					schools: '',
				}),
				campusPickerOptions: {
					disabledDate(time) {
						const today = new Date()
						today.setHours(0, 0, 0, 0)
						return time.getTime() < today.getTime();
					}
				},
				campusPickerOptions1: {
					disabledDate: (time) => {
						const today = new Date()
						today.setHours(0, 0, 0, 0)
						if (this.campusForm.stime) {
							return time.getTime() < today.getTime() || time.getFullYear() !== this.campusForm.stime.getFullYear() ||
								time.getMonth() !== this.campusForm.stime.getMonth() || time.getDate() !== this.campusForm.stime.getDate();
						}
						return time.getTime() < today.getTime();
					}
				},
				dialogVisible: false,
				idx: 0,
				imageUrl: '',
				name: '',
				textarea1: '',
				options: [{
					value: '男',
					label: '男'
				}, {
					value: '女',
					label: '女'
				}],
				value: '',

				startTime: '',
				endTime: '',

				pickerOptions: {
					disabledDate(time) {
						const oneDay = 86400000;
						return time.getTime() < Date.now();
					}
				},
				pickerOptions1: {
					// disabledDate: =>(time) {
					// 	return time.getTime() != this.liveList[0].stime ;
					// },
					disabledDate: (time) => {
						const oneDay = 86400000;
						if(this.liveList[0].stime){
							return time.getTime() < Date.now() || time.getFullYear() !== this.liveList[0].stime
								.getFullYear() ||
								time.getMonth() !== this.liveList[0].stime.getMonth() ||
								time.getDate() !== this.liveList[0].stime.getDate();
						}
					
							
					}
				},
				// stime: '', //直播开始时间
				// etime: '', //直播结束时间
				// title: '', //直播标题
				// event_person: '', //主讲人
				// person_desc: '', //主讲人介绍
				// header_intr: '', //主讲人头衔
				// event_desc: '', //直播内容简介
				// event_img: '', //直播海报
				liveList: [{
					stime: '', //直播开始时间
					etime: '', //直播结束时间
					title: '', //直播标题
					event_person: '', //主讲人
					person_desc: '', //主讲人介绍
					header_intr: '', //主讲人头衔
					event_desc: '', //直播内容简介
					event_img: '', //直播海报
					phone: '',
					isSelect: true,
				}],
				selectIdx: 0,


				value1: '',
				xet_alive_code: '',

				isAmend: false
			};
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		mounted() {

			this.getkyjoblist()
			this.getCareerTalk()
			this.updateBreadcrumb()
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		beforeRouteLeave(to, from, next) {
			this.confirmCampusLeave(() => next(), () => next(false))
		},
		methods: {
			...mapMutations(['setIslogin']),
			changeTab(tab) {
				if (tab === this.activeTab) return
				this.confirmCampusLeave(() => {
					this.activeTab = tab
					this.updateBreadcrumb()
				})
			},
			getCampusFormSnapshot() {
				return JSON.stringify({
					stime: this.campusForm.stime ? new Date(this.campusForm.stime).getTime() : '',
					etime: this.campusForm.etime ? new Date(this.campusForm.etime).getTime() : '',
					session: this.campusForm.session,
					schoolType: this.campusForm.schoolType,
					schools: this.campusForm.schools,
				})
			},
			setCampusFormSnapshot() {
				this.campusFormSnapshot = this.getCampusFormSnapshot()
			},
			hasUnsavedCampusForm() {
				return this.activeTab === 'campus' && this.getCampusFormSnapshot() !== this.campusFormSnapshot
			},
			confirmCampusLeave(proceed, stay) {
				if (!this.hasUnsavedCampusForm()) {
					proceed()
					return
				}
				this.$confirm('您尚未提交进校宣讲报名信息！', '提示', {
					confirmButtonText: '继续报名',
					cancelButtonText: '取消报名',
					type: 'warning',
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
				}).then(() => {
					if (stay) stay()
				}).catch(() => {
					proceed()
				})
			},
			updateBreadcrumb() {
				if (this.$parent && this.$parent.navigation) {
					this.$parent.navigation = [{
						name: '双选会',
						path: '/meeting'
					}, {
						name: '/',
						path: '/'
					}, {
						name: this.activeTab === 'campus' ? '进校宣讲报名' : '线上宣讲报名',
						path: '/wednesday'
					}]
				}
			},
			campusStartTimeChange() {
				this.campusForm.isSelect = false
				this.campusForm.etime = new Date(this.campusForm.stime.getTime() + 2 * 60 * 60 * 1000)
			},
			campusEtimeChange() {
				if (new Date(this.campusForm.stime) >= new Date(this.campusForm.etime)) {
					this.$message.error('开始时间需小于结束时间!')
					this.campusForm.etime = ''
				}
			},
			resetCampusForm() {
				this.campusForm = {
					stime: '',
					etime: '',
					session: '',
					schoolType: '',
					schools: '',
					isSelect: true,
				}
			},
			getCareerTalk() {
				this.$util.post('v2/school_job/getCareerTalk', {
					admin_id: this.schoolInfo.admin_id,
				}, (res) => {
					const careerTalk = res && res.data
					const hasCareerTalk = careerTalk && !Array.isArray(careerTalk) && Object.keys(careerTalk).length > 0
					if (res && (res.code == 0 || res.code == 200) && hasCareerTalk) {
						const meetingTime = careerTalk.meeting_time ? careerTalk.meeting_time.split(' 至 ') : []
						this.campusForm = {
							stime: meetingTime[0] ? new Date(meetingTime[0]) : '',
							etime: meetingTime[1] ? new Date(meetingTime[1]) : '',
							session: careerTalk.meeting_name || '',
							schoolType: careerTalk.school_type || '',
							schools: careerTalk.school_name || '',
							isSelect: !meetingTime[0],
						}
						this.isCampusAmend = true
					}
					this.setCampusFormSnapshot()
				})
			},
			cancelCampus() {
				this.$confirm('是否取消该宣讲报名?', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$util.post('v2/school_job/delCareerTalk', {
						admin_id: this.schoolInfo.admin_id,
					}, (res) => {
						if (res.code == 0 || res.code == 200) {
							this.$message.success('取消成功')
							this.resetCampusForm()
							this.setCampusFormSnapshot()
							setTimeout(() => {
								let is_demo = sessionStorage.getItem('demo')
								this.$router.push({
									path: is_demo ? '/meeting?demo=' + is_demo : '/meeting',
								})
							}, 1000)
						} else {
							this.$message.error(res.msg || '取消失败')
						}
					})
				}).catch(() => {})
			},
			submitCampus() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
						})
					}).catch(() => {})
					return
				}
				if (!this.campusForm.stime || !this.campusForm.etime) {
					this.$message.error('请填写宣讲时间')
					return
				}
				if (!this.campusForm.session.trim()) {
					this.$message.error('请填写宣讲场次')
					return
				}
				if (!this.campusForm.schoolType.trim()) {
					this.$message.error('请填写高校类型')
					return
				}
				if (!this.campusForm.schools.trim()) {
					this.$message.error('请填写具体高校')
					return
				}
				this.$util.post('v2/school_job/saveCareerTalk', {
					admin_id: this.schoolInfo.admin_id,
					meeting_name: this.campusForm.session.trim(),
					meeting_time: this.$getTime('-', 1, this.campusForm.stime) + ' 至 ' + this.$getTime('-', 1, this.campusForm.etime),
					school_type: this.campusForm.schoolType.trim(),
					school_name: this.campusForm.schools.trim(),
				}, (res) => {
					if (res.code == 0 || res.code == 200) {
						this.$message.success('保存成功')
						this.setCampusFormSnapshot()
						setTimeout(() => {
							if (!this.isCampusAmend && !this.isAmend) {
								this.activeTab = 'live'
								this.updateBreadcrumb()
								return
							}
							let is_demo = sessionStorage.getItem('demo')
							this.$router.push({
								path: is_demo ? '/meeting?demo=' + is_demo : '/meeting',
							})
						}, 1000)
					} else {
						this.$message.error(res.msg || '保存失败')
					}
				})
			},
			delWeixin(index) {
				this.liveList[index].event_img = ''
			},
			etimeChange(index) {
				// console.log(index)
				// console.log(this.liveList[index].etime)
				if (this.liveList[index].etime) {
					if (new Date(this.liveList[index].stime) >= new Date(this.liveList[index].etime)) {
						this.$message.error('开始时间需小于结束时间!');
						this.liveList[index].etime = ''
					}
				}

			},
			cancel() {
				const that = this
				this.$confirm('是否取消该宣讲报名', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let obj = {
						live_id: that.liveList[0].id,
						admin_id: that.schoolInfo.admin_id,
					}
					console.log()
					this.$util.post(
						"v2/delLiveEvent", {
							...obj
						},
						(res) => {
							if (res.code == 200) {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								setTimeout(() => {
									let is_demo = sessionStorage.getItem('demo')
									if(is_demo){
										this.$router.push({
											path: '/meeting?demo='+is_demo,
										})
									}else{
										this.$router.push({
											path: '/meeting',
										})
									}
								}, 1000)
							}
						}
					);
				}).catch(() => {

				});
			},
			openPDF() {
				window.open(
					'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/12/wanqiduijie.pdf',
					'_blank')
			},
			timeChange(index) {
				// if(index){
				// 	this.liveList[index].stime = this.$getTime('-',1,this.liveList[index].value1[0])
				// 	this.liveList[index].etime = this.$getTime('-',1,this.liveList[index].value1[1])
				// }else{
				// 	this.liveList[index].stime = ''
				// 	this.liveList[index].etime = ''
				// }


			},
			liveStreaming(str) {
				this.xet_alive_code = str
				this.dialogVisible = true
			},
			closeElDialog() {
				this.dialogVisible = false
			},
			// new Date(stime).getTime()
			async submit() {
				console.log(this.liveList)
				
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				let liveList = JSON.parse(JSON.stringify(this.liveList))

				let isNull = ''
				const regex = /^1[3-9]\d{9}$/;
				for (let i = 0; i < liveList.length; i++) {
					// liveList[i].value1 = liveList[i].value1.trim()
					liveList[i].title = liveList[i].title.trim()
					liveList[i].event_person = liveList[i].event_person.trim()
					liveList[i].person_desc = liveList[i].person_desc.trim()
					liveList[i].header_intr = liveList[i].header_intr.trim()
					liveList[i].event_desc = liveList[i].event_desc.trim()
					liveList[i].event_img = liveList[i].event_img.trim()
					liveList[i].phone = liveList[i].phone.trim()

					liveList[i].stime = liveList[i].stime
					liveList[i].etime = liveList[i].etime





					if (!liveList[i].event_img) {
						isNull = '请上传直播海报'
					}
					if (!liveList[i].event_desc) {
						isNull = '请填写直播内容简介'
					}
					if (!liveList[i].person_desc) {
						isNull = '请填写主讲人介绍'
					}
					if (!regex.test(liveList[i].phone)) {
						isNull = '手机号格式错误'
					}
					if (!liveList[i].phone) {
						isNull = '请填写主讲人手机号'
					}
					if (!liveList[i].header_intr) {
						isNull = '请填写主讲人头衔'
					}
					if (!liveList[i].event_person) {
						isNull = '请填写主讲人名称'
					}
					
					if(new Date(liveList[i].etime).getTime() < Date.now()){
						isNull = '结束时间需大于当前时间!'
					}
					
					if(new Date(liveList[i].stime).getTime()< Date.now()){
						isNull = '开始时间需大于当前时间!'
					}
					if (!liveList[i].stime || !liveList[i].etime) {
						isNull = '请选择直播时间段'
					}
					if (!liveList[i].title) {
						isNull = '请填写直播标题'
					}

					// if (liveList[i].value1 ==''|| liveList[i].title == '' || liveList[i]
					// 	.event_person == '' || liveList[i].person_desc == '' || liveList[i].header_intr == '' ||
					// 	liveList[i].event_desc == '' || liveList[i].event_img == '') {
					// 	isNull = true
					// 	break
					// }
				}
				if (isNull) {
					this.$message({
						message: isNull,
						type: 'error'
					});
					return
				}

				liveList.forEach((item, index, arr) => {
					arr[index].stime = this.$getTime('-', 1, this.liveList[index].stime)
					arr[index].etime = this.$getTime('-', 1, this.liveList[index].etime)
				})

				// if(giftList1.length>0){

				if (liveList.length > 0) {
					await Promise.all(liveList.map(async item => {
						await this.addLiveEvent(item);
					})).then(() => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						setTimeout(() => {
							let is_demo = sessionStorage.getItem('demo')
							if(is_demo){
								this.$router.push({
									path: '/meeting?demo='+is_demo,
								})
							}else{
								this.$router.push({
									path: '/meeting',
								})
							}
						}, 1000)
					})
				}
				// }else{
				// 	this.$message({
				// 		message: '请填写直播信息',
				// 		type: 'error'
				// 	});
				// }

			},
			addLiveEvent(item) {
				return new Promise((resolve) => {
					let obj = {
						stype: 5,
						admin_id: this.schoolInfo.admin_id,
						...item
					}
					if (item.id) {
						obj.live_id = item.id
					}
					this.$util.post(
						"v2/addLiveEvent", {
							...obj
						},

						(res) => {

							if (res.code == 200) {

								this.getkyjoblist()
								resolve(res)
							}
						}
					);
				})
			},
			deleteItem(index) {
				if (this.liveList[index].id) {
					const that = this
					that.$confirm('是否删除该活动预告?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let obj = {
							live_id: that.liveList[index].id,
							admin_id: that.schoolInfo.admin_id,
						}
						this.$util.post(
							"v2/delLiveEvent", {
								...obj
							},
							(res) => {

								if (res.code == 200) {
									if (that.liveList.length == 1) {
										that.liveList.splice(index, 1)
										that.liveList.push({
											stime: '', //直播开始时间
											etime: '', //直播结束时间
											title: '', //直播标题
											event_person: '', //主讲人
											person_desc: '', //主讲人介绍
											header_intr: '', //主讲人头衔
											event_desc: '', //直播内容简介
											event_img: '', //直播海报
											isSelect: true,
											value1: '',
											phone: '',
										})
									} else {
										that.liveList.splice(index, 1)
									}
									this.$message({
										type: 'success',
										message: '删除成功!'
									});
								}
							}
						);
					}).catch(() => {

					});
				} else {

					if (this.liveList.length == 1) {
						this.liveList.splice(index, 1)
						this.liveList.push({
							stime: '', //直播开始时间
							etime: '', //直播结束时间
							title: '', //直播标题
							event_person: '', //主讲人
							person_desc: '', //主讲人介绍
							header_intr: '', //主讲人头衔
							event_desc: '', //直播内容简介
							event_img: '', //直播海报
							isSelect: true,
							value1: '',
							phone: '',
						})
					} else {
						this.liveList.splice(index, 1)
					}
				}
			},
			getkyjoblist() {
				this.$util.get(
					"v2/getLiveEvent", {
						stype: 5,
						admin_id: this.schoolInfo.admin_id,
					}, (res) => {
						if (res.code == 200) {
							if (res.data.length > 0) {
								this.isAmend = true
							}
							let liveList = res.data.map((item) => {
								return {
									...item,
									stime: new Date(item.stime),
									etime: new Date(item.etime),
									value1: [new Date(item.stime), new Date(item.etime)]
								}
							})
							console.log(liveList)
							if (liveList.length == 0) {
								liveList.push({
									stime: '', //直播开始时间
									etime: '', //直播结束时间
									title: '', //直播标题
									event_person: '', //主讲人
									person_desc: '', //主讲人介绍
									header_intr: '', //主讲人头衔
									event_desc: '', //直播内容简介
									event_img: '', //直播海报
									isSelect: true,
									value1: '',
									phone: '',
								})
							}
							this.liveList = liveList

						} else {
							// this.$message({
							// 	showClose: true,
							// 	message: res.msg,
							// 	type: 'error'
							// });
						}
					}
				);
			},
			selectIndex(index) {
				this.idx = index
			},
			handleAvatarSuccess(res, file) {
				this.liveList[this.idx].event_img = file.response.data.fileUrl;
			},
			beforeAvatarUpload(file) {

				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB');
					return
				}

				return isLt2M && img;
			},
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
				switch (status) {
					case 0:
						return Y + M + D;
					case 1:
						return Y + M + D + H + Minu + S;
					default:
						break;
				}
			},
			getTime(dateTimeString) {
				const dateTime = new Date(dateTimeString);

				const year = dateTime.getUTCFullYear();
				const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0');
				const day = String(dateTime.getUTCDate()).padStart(2, '0');
				const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				const formattedDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;


				return formattedDateTime
			},
			selectTime(idx) {

				this.selectIdx = idx
			},

			startTimeChange(val) {

				this.liveList[this.selectIdx].isSelect = false
				this.liveList[this.selectIdx].etime = ''
			},
			disabledDate(time) {
				if (this.liveList[this.selectIdx].stime !== '') {
					return time.getTime() <= this.liveList[this.selectIdx].stime.getTime();
				} else {
					return false
				}

			},



			addLive() {
				this.liveList.push({
					stime: '', //直播开始时间
					etime: '', //直播结束时间
					title: '', //直播标题
					event_person: '', //主讲人
					person_desc: '', //主讲人介绍
					header_intr: '', //主讲人头衔
					event_desc: '', //直播内容简介
					event_img: '', //直播海报
					isSelect: true,
					value1: '',
					phone: '',
				})
			},

		},
		components: {},
	};
</script>
<style>
	#wednesday .cancel{
		color: #AEAEAE !important;
		background: #ffffff !important;
		border-color: #d0d0d0 !important;
	}
	
	#wednesday .avatar-uploader1 .el-upload {
		border: none !important;
	}

	#wednesday .el-date-editor.el-input__inner {
		flex: 1 !important;
	}
</style>
<style lang="less" scoped>
	.closeContainer:hover .closeImg {
		display: inline-block;
	}
	.closeImg {
		display: none;
	}
	.container {
		width: 100%;
		padding: 0 40px;

		.tabContainer {
			display: flex;
			align-items: center;
			gap: 28px;
			margin-bottom: 14px;

			.tabItem {
				position: relative;
				padding: 10px 0;
				font-size: 16px;
				color: #606266;
				cursor: pointer;

				&.active {
					font-weight: bold;
					color: #303133;
				}

				&.active::after {
					content: '';
					position: absolute;
					left: 50%;
					bottom: 0;
					width: 28px;
					height: 4px;
					background: #1472FF;
					border-radius: 2px;
					transform: translateX(-50%);
				}
			}
		}

		.campusForm {
			.ipt {
				width: 700px;
				display: flex;
				align-items: center;
				margin-bottom: 32px;

				.text {
					width: 110px;
					padding-top: 0;
					margin-right: 10px;
					text-align: right;
					font-size: 14px;
					color: #000;
					white-space: nowrap;
				}

				.el-textarea,
				.el-date-editor {
					flex: 1;
				}
			}

			.campusTextarea {
				align-items: flex-start;

				.text {
					padding-top: 10px;
				}
			}

			.campusTextarea .el-textarea__inner {
				resize: none;
			}

			.campusTextareaLarge {
				margin-bottom: 34px;
			}
		}

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 0 0 0;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				// .avatarContainer {
				// 	display: flex;
				// 	// align-items: center;
				// 	align-items: flex-start;
				// 	margin-bottom: 30px;

				// 	.text {
				// 		width: 100px;
				// 		display: flex;
				// 		align-items: center;
				// 		font-weight: 500;
				// 		font-size: 18px;
				// 		color: #333333;
				// 		margin-right: 20px;
				// 	}

				// 	.upload {
				// 		margin-right: 20px;
				// 	}

				// 	.uploadContainer {
				// 		display: flex;
				// 		align-items: center;

				// 		.uploadText {
				// 			width: 310px;
				// 			font-weight: 500;
				// 			font-size: 16px;
				// 			color: #999999;
				// 		}
				// 	}

				// }

				.ipt {
					width: 700px;
					display: flex;
					align-items: center;
					margin-bottom: 28px;

					.text {
						// width: 135px;
						width: 110px;
						display: flex;
						align-items: center;
						margin-right: 10px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						justify-content: flex-end;

						span {
							font-weight: 500;
							font-size: 14px;
							color: #000;
						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
					}
				}

			}

			.btnContainer {
				width: 700px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;

				// .el-button--primary {
				// 	background-color: #0084FF !important;
				// 	border-color: #0084FF !important;
				// 	// border-radius: 10px !important;
				// }
			}
		}


	}

	.companyContainer {
		display: flex;
		align-items: flex-start;
		width: 700px;

		.text {
			width: 110px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-weight: 400;
			font-size: 14px;
			color: #000;
			margin-right: 10px;
		}

		.el-input {
			flex: 1 !important;
		}

		.company {
			flex: 1;
			background: #FFFFFF;
			border-radius: 5px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			padding: 15px 15px 20px 15px;

			.top {
				display: flex;
				align-items: center;
				width: 100%;
				border-bottom: 1px solid #dcdcdc69;
				margin-bottom: 20px;

				padding: 0 5px 15px 5px;

				.uplodadCompany1 {}

				.uplodadCompany {
					display: flex;
					align-items: center;
					font-size: 0;
					margin-left: 10px;

					img {
						width: 20px;
						height: 20px;
						margin-right: 12px;
					}

					.btn {
						font-weight: 500;
						font-size: 14px;
						color: #3A84E9;
					}
				}
			}

			.companyImg {
				display: flex;
				align-items: center;
				// padding: 0 15px;
				font-size: 0;

				img {
					width: 195px;
					height: 120px;
					margin-right: 15px;
				}

				div {
					font-weight: 500;
					font-size: 14px;
					color: #999;
					display: flex;
					// align-items: center;
					justify-content: space-between;
					flex-direction: column;
				}

			}
		}
	}

	.addNewContainer {
		width: 700px;
		display: flex;
		// align-items: flex-end;
		justify-content: flex-end;
		margin-bottom: 30px;

		.addNew {
			width: 600px;
			height: 60px;
			background: #f9fbff;
			border-radius: 5px;

			text-align: center;
			line-height: 60px;
			font-weight: 500;
			font-size: 14px;
			color: #3A84E9;
			cursor: pointer;
		}
	}



	.bg {
		width: 700px;
		height: 120px;
		background-image: url(../img/bg5.png);
		background-repeat: no-repeat;
		cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 30px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		.title {
			color: #20A4D5;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}

		.subheading {
			font-size: 0;
			display: flex;
			align-items: center;

			div {
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}

			img {
				width: 10px;
				height: 10px;
			}
		}
	}

	.campusBg {
		background-image: url('https://oss.sx985.com/2026/08/29/xxxx1111e.png');
		background-size: cover;
		background-position: center;

		.title {
			color: #1295B8;
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #ffffff;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 100px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			img {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}
</style>

<style>
	#wednesday .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	#register .el-input__inner {
		font-size: 16px;
	}

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
